import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import ListIcon from '@mui/icons-material/List';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SettingsIcon from '@mui/icons-material/Settings';
import StoreIcon from '@mui/icons-material/Store';
import StorefrontIcon from '@mui/icons-material/Storefront';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import PaymentsIcon from '@mui/icons-material/Payments';
import { Link, useNavigate } from 'react-router-dom';
import './sidebar.css';
import { ReactComponent as DigntecLogo } from "../../Assets/images/DigntecLogo.svg";
import { ReactComponent as LogoutIcon } from "../../Assets/images/logoutIcon.svg";
import { logout } from '../../Redux/Actions/userAction';
import {useDispatch} from 'react-redux';
import { useMediaQuery } from '@mui/material';

// Pages visible per role
const ROLE_WHITELIST = {
    admin:         ['/', '/content', '/user', '/screen', '/playlist', '/store', '/seasonal', '/payment', '/menu-master'],
    designer:      ['/', '/content', '/playlist', '/user', '/store', '/menu-master'],
    store_owner:   ['/', '/screen', '/store', '/storeportal'],
    store_manager: ['/', '/storeportal'],
    tlj_manager:   ['/', '/storeportal'],
    tlj_admin:     ['/', '/storeportal', '/tlj'],
};

function Sidebar({ user }) {
    const isMobile = useMediaQuery('(max-width:600px)');
    const dispatch=useDispatch();
    const navigate=useNavigate();
    const logoutHandler=()=>{
        dispatch(logout())
        return navigate('/login')
    }

    const allowed = ROLE_WHITELIST[user?.role] || ROLE_WHITELIST['admin'];
    const can = (path) => allowed.includes(path);

    const textStyle = { fontSize: 15, color: '#B8B8B8', fontFamily: 'Open Sans', display: isMobile ? 'none' : undefined };

    return (
        <>
            <div className="sidebar-container" style={isMobile ? { width: '70px' } : {}}>
                <div className="sidebar-upper-sec" style={isMobile ? { display: 'flex', justifyContent: 'center', alignItems: 'center', width: '70px', height: '20vh' } : {}}>
                    <DigntecLogo style={{ width: '130px', height: 'auto' }} />
                </div>
                <div className="sidebar-middle-sec">
                    <div className="side-bar-box">
                        {can('/') &&
                        <Link className="links" data-label="Dashboard" style={{ textDecoration: 'none' }} onClick={() => {}} to='/'>
                            <div className='link-icon'><DashboardIcon className='link-a-color' /></div>
                            <span style={textStyle}>Dashboard</span>
                        </Link>}

                        {can('/content') &&
                        <Link className="links" data-label="Content" style={{ textDecoration: 'none' }} onClick={() => {}} to="/content">
                            <div className='link-icon'><TextSnippetIcon className='link-a-color' /></div>
                            <span style={textStyle}>Content</span>
                        </Link>}

                        {can('/user') &&
                        <Link className="links" data-label="User" style={{ textDecoration: 'none' }} onClick={() => {}} to="/user">
                            <div className='link-icon'><PersonAddIcon className='link-a-color' /></div>
                            <span style={textStyle}>User</span>
                        </Link>}

                        {can('/screen') &&
                        <Link className="links" data-label="Screen" style={{ textDecoration: 'none' }} onClick={() => {}} to="/screen">
                            <div className='link-icon'><DesktopMacIcon className='link-a-color' /></div>
                            <span style={textStyle}>Screen</span>
                        </Link>}

                        {can('/playlist') &&
                        <Link className="links" data-label="Playlist" style={{ textDecoration: 'none' }} onClick={() => {}} to="/playlist">
                            <div className='link-icon'><ListIcon className='link-a-color' /></div>
                            <span style={textStyle}>Playlist</span>
                        </Link>}

                        {can('/store') &&
                        <Link className="links" data-label="Store" style={{ textDecoration: 'none' }} onClick={() => {}} to="/store">
                            <div className='link-icon'><StoreIcon className='link-a-color' /></div>
                            <span style={textStyle}>Store</span>
                        </Link>}

                        {can('/seasonal') &&
                        <Link className="links" data-label="Seasonal" style={{ textDecoration: 'none' }} onClick={() => {}} to="/seasonal">
                            <div className='link-icon'><RestaurantMenuIcon className='link-a-color' /></div>
                            <span style={textStyle}>Seasonal</span>
                        </Link>}

                        {can('/menu-master') &&
                        <Link className="links" data-label="Menu Master" style={{ textDecoration: 'none' }} onClick={() => {}} to="/menu-master">
                            <div className='link-icon'><RestaurantMenuIcon className='link-a-color' /></div>
                            <span style={textStyle}>메뉴 마스터</span>
                        </Link>}

                        {can('/payment') &&
                        <Link className="links" data-label="Payment" style={{ textDecoration: 'none' }} onClick={() => {}} to="/payment">
                            <div className='link-icon'><PaymentsIcon className='link-a-color' /></div>
                            <span style={textStyle}>Payment</span>
                        </Link>}

                        {can('/storeportal') &&
                        <Link className="links" data-label="My Store" style={{ textDecoration: 'none' }} onClick={() => {}} to="/storeportal">
                            <div className='link-icon'><StorefrontIcon className='link-a-color' /></div>
                            <span style={textStyle}>My Store</span>
                        </Link>}

                        {can('/tlj') &&
                        <Link className="links" data-label="TLJ" style={{ textDecoration: 'none' }} onClick={() => {}} to="/tlj">
                            <div className='link-icon'><StorefrontIcon className='link-a-color' /></div>
                            <span style={textStyle}>TLJ EAST/WEST</span>
                        </Link>}

                        <div className="links" data-label="Logout" style={{ cursor: 'pointer' }} onClick={logoutHandler}>
                            <div className='link-icon'><ExitToAppIcon className='link-a-color' /></div>
                            <span style={textStyle}>Logout</span>
                        </div>
                    </div>
                </div>
                <div className="sidebar-bottom-sec">
                    <div className="settings">
                        <SettingsIcon style={{ color: 'white' }} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Sidebar
